<i18n>
{
  "fr": {
    "return-home-btn": "Retour",
    "forgot-password-title": "Mot de passe oublié?",
    "forgot-password-email-sent-text": "Un message pour réinitialiser votre mot de passe a été envoyé à {email}.",
    "forgot-password-cancel-btn": "Retour",
    "forgot-password-email-label": "Courriel",
    "forgot-password-email-placeholder": "Ex: courriel@domaine.com",
    "forgot-password-submit-btn": "Envoyer un courriel",
    "error-forgot-password-email-empty": "Le champ courriel ne doit pas être vide",
    "error-forgot-password-email-invalid": "Le courriel doit être dans un format valide : email@domain.com"
  },
  "en": {
    "return-home-btn": "Go back",
    "forgot-password-title": "Forgot your password?",
    "forgot-password-email-sent-text": "A message to reset your password has been sent to {email}.",
    "forgot-password-cancel-btn": "Go back",
    "forgot-password-email-label": "Email",
    "forgot-password-email-placeholder": "Ex: email@domain.com",
    "forgot-password-submit-btn": "Send an email",
    "error-forgot-password-email-empty": "The email field must not be empty.",
    "error-forgot-password-email-invalid": "The email address must be in a valid format: email@domain.com"
  }
}
</i18n>

<template>
  <welcome>
    <template v-if="emailSent">
      <router-link :to="{ name: $consts.urls.URL_ACCOUNT_LOGIN }">
        <span class="icon">
          <i class="fas fa-arrow-left"></i>
        </span>
        <span class="has-text-underline">{{ $t('return-home-btn') }}</span>
      </router-link>
      <h1 class="title">{{ $t('forgot-password-title') }}</h1>
      <p v-html="$t('forgot-password-email-sent-text', { email: `<span class='has-text-weight-medium'>${email}</span>` })"></p>
    </template>
    <template v-else>
      <router-link :to="{ name: $consts.urls.URL_ACCOUNT_LOGIN }">
        <span class="icon">
          <i class="fas fa-arrow-left"></i>
        </span>
        <span class="has-text-underline">{{ $t('forgot-password-cancel-btn') }}</span>
      </router-link>
      <h1 class="title">{{ $t('forgot-password-title') }}</h1>
      <s-form ref="form" @submit="sendEmail">
        <s-field
          :label="$t('forgot-password-email-label')"
          label-for="email"
          :value="email"
          :rules="rules.emailRules"
          validate-on-input
        >
          <b-input v-model="email" :placeholder="$t('forgot-password-email-placeholder')" id="email"></b-input>
        </s-field>
        <p class="mt-32px">
          <b-button :loading="loading" class="is-fullwidth" type="is-link" outlined size="is-medium" native-type="submit">
            {{ $t('forgot-password-submit-btn') }}
          </b-button>
        </p>
      </s-form>
    </template>
  </welcome>
</template>

<script>
import SForm from '@/components/form/form'
import SField from '@/components/form/field'
import Welcome from '@/components/layout/welcome'

import UserService from '@/services/user'

import FormHelper from '@/helpers/form'

export default {
  data() {
    return {
      loading: false,
      emailSent: false,
      email: '',
      rules: {
        emailRules: [
          (value) => !FormHelper.stringEmpty(value) || this.$t('error-forgot-password-email-empty'),
          (value) => FormHelper.isEmail(value) || this.$t('error-forgot-password-email-invalid')
        ]
      }
    }
  },
  components: {
    SForm,
    SField,
    Welcome
  },
  methods: {
    sendEmail: async function () {
      if (this.$refs.form.validate()) {
        this.loading = true

        try {
          await UserService.sendPasswordReset(this.email)
          this.emailSent = true
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
